"use strict";

import AppUtil from "/js/util/app-util.js"
import PrimerMaster from "/js/util/primermaster.js"
import UserLessons from "/js/core/user-lessons.js"
import Strings from "/js/util/strings.js";
import FocusUtil from "/js/util/focus-util.js";

/** 
 * List item in the minicourse view's list.
 */
export default class MinicourseListItemView {

  static _TEMPLATE_STRING 
      =  `<div class="minicourseListItem" tabindex="100">
            <div class="circle <%= circleColorClass %>" ></div>
            <img class="image" src="<%= image %>" alt="" aria-hidden="true">
            <div class="texts">
              <div class="title"><%= title %></div>
              <div class="credit"><%= creditLine %></div>
            </div>
            <div class="bottomHolder">
              <div class="skill-line"><span class="image-helper"></span><img src="<%= skillIcon %>" alt="" aria-hidden="true" style="top:<%= skillIconOffset %>"><span><%= skillLabel %></span></div>
              <div class="bar">
                <div class="barBg"></div>
                <div class="barFg"></div>
              </div>
              <div class="recapCta"><%= recapString %></div>
              <div class="startCta"><%= startString %></div>
            </div>
          </div>`;
  static _TEMPLATE = _.template(MinicourseListItemView._TEMPLATE_STRING);

  #$el;
  #$title;
  #$credit;
  #$circle;
  #$image;
  #$progressBar;

  #lessonId;

  /**
   * @oparam data is the lesson metadata object from the lessons array of the PrimerMaster json.
   */
  constructor(data) {

    this.#lessonId = data.id;

    const o = {};
    o.title = data.title;

    const creditString = Strings.get("lesson_credit");
    const localizedCredit = creditString.replace("%1$s", data.credit);
    o.creditLine = localizedCredit;

    // Construct feature image path by convention.
    const fn = `feature-${ data.id.replace("lesson-", "") }.svg`;
    const path = `${data.id}/assets/${fn}`; 
    o.image = AppUtil.makeLessonAssetPath(path);
    o.circleColorClass = PrimerMaster.getBgColorClassForLessonId(data.id);

    o.skillIcon = "";
    o.skillIconOffset = "0px";
    o.skillLabel = "";
    const skill = PrimerMaster.getSkillForLessonId(data.id);    
    if (skill) {
      o.skillIcon = PrimerMaster.getSkillIconPath(skill.id);
      o.skillIconOffset = PrimerMaster.getSkillIconOffset(skill.id) + "px";
      o.skillLabel = skill.label;
    }

    o.recapString = Strings.get("recap_singular");
    o.startString = Strings.get("generic_start_button");

    const s = MinicourseListItemView._TEMPLATE(o);

    const div = $.parseHTML(s);
    this.#$el = $(div);

    this.#$circle = this.#$el.find(".circle");
    this.#$progressBar = this.#$el.find(".barFg");
    this.#$progressBar.addClass(PrimerMaster.getBgDarkColorClassForLessonId(this.#lessonId));

    this.#$el.on("click tap", e => {
      $(window).trigger('minicourse-list-item', data.id);
    });
    FocusUtil.doStandardTreatment(this.#$el);

    // "Start" CTA text color
    const startColorCls = PrimerMaster.getColorClassForLessonId(this.#lessonId);
    this.#$el.find(".startCta").addClass(startColorCls);

    this.update();
  }

  /**
   * Updates the view's state.
   */
  update() {
    const userLesson = UserLessons.getByLessonId(this.#lessonId);
    const isComplete = userLesson && userLesson.isComplete;
    const inProgressPercent = userLesson && userLesson.inProgressPercent
    const isInProgress = !isComplete && !isNaN(inProgressPercent);

    if (isInProgress) {
      this.#$el.removeClass("isComplete");
      this.#$el.addClass("isInProgress");
      let pct = Math.max(10, inProgressPercent * 100);  // bc looks awkward if too small
      pct = Math.round(pct) + "%";
      this.#$progressBar.width(pct);
      // The value of width can stay at "0%" without doing this (Chrome on Linux, c. 2020-03)
      setTimeout(() => { this.#$progressBar.width(pct); }, 1);
    } else if (isComplete) {
      this.#$el.removeClass("isInProgress");
      this.#$el.addClass("isComplete");
    } else {  // is untouched
      this.#$el.removeClass("isInProgress");
      this.#$el.removeClass("isComplete");
    }
  }

  get $el() {
    return this.#$el;
  }

  get lessonId() {
    return this.#lessonId;
  }
}
